<template>
    <div class="row">
            <div class="col-md-3 col-sm-6 col-12">
                <div class="info-box bg-info">
                    <span class="info-box-icon"
                        ><i class="far fa-bookmark"></i
                    ></span>

                    <div class="info-box-content">
                        <span class="info-box-text">Total positive</span>
                        <span class="info-box-number">79,101</span>
                        <span class="progress-description"> </span>
                    </div>
                    <!-- /.info-box-content -->
                </div>
                <!-- /.info-box -->
            </div>
            <!-- /.col -->
            <div class="col-md-3 col-sm-6 col-12">
                <div class="info-box bg-success">
                    <span class="info-box-icon"
                        ><i class="far fa-thumbs-up"></i
                    ></span>

                    <div class="info-box-content">
                        <span class="info-box-text">ART registered</span>
                        <span class="info-box-number"> (8,000)</span>

                        <!-- <div class="progress">
                            <div class="progress-bar" style="width: 20%"></div>
                        </div> -->
                        <span class="progress-description"> </span>
                    </div>
                    <!-- /.info-box-content -->
                </div>
                <!-- /.info-box -->
            </div>
            <div class="col-md-3 col-sm-6 col-12">
                <div class="info-box bg-success">
                    <span class="info-box-icon"
                        ><i class="far fa-thumbs-up"></i
                    ></span>

                    <div class="info-box-content">
                        <span class="info-box-text">New ART reg</span>
                        <span class="info-box-number">1,520 - (8,000)</span>

                        <div class="progress">
                            <div class="progress-bar" style="width: 20%"></div>
                        </div>
                        <span class="progress-description"> </span>
                    </div>
                    <!-- /.info-box-content -->
                </div>
                <!-- /.info-box -->
            </div>
            <!-- /.col -->
            <div class="col-md-3 col-sm-6 col-12">
                <div class="info-box bg-warning">
                    <span class="info-box-icon"
                        ><i class="far fa-calendar-alt"></i
                    ></span>

                    <div class="info-box-content">
                        <span class="info-box-text">AAU referral</span>
                        <span class="info-box-number">4,100 - (26,000)</span>

                        <div class="progress">
                            <!-- 26,0000 -->
                            <div class="progress-bar" style="width: 30%"></div>
                        </div>
                        <span class="progress-description">
                            <!-- 70% Increase in 30 Days -->
                        </span>
                    </div>
                    <!-- /.info-box-content -->
                </div>
                <!-- /.info-box -->
            </div>

    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>